import { Component, input } from '@angular/core';

@Component({
  selector: 'app-price',
  standalone: false,
  templateUrl: './price.component.html',
  styleUrl: './price.component.scss',
})
export class PriceComponent {
  price = input<number>();
}
